<template>
    <aside class="remodal">
        <button data-remodal-action="close" class="remodal-close">
            <i class="material-icons">close</i>
        </button>


        <div class="profile profile--vertical mb--20">
            <figure class="profile__avatar">
                <div class="btn btn--white btn--wrapper text--center mb--md">
                    <svg class="icon"><use xlink:href="/img/icon-sprite.svg#coupon"></use></svg>
                </div>
            </figure>
        </div>

        <h4 class="modal__title">
            Add Coupon
        </h4>

        <div v-show="successMsg" class="mb--md c--success">
            {{ successMsg }}
        </div>

        <div v-show="errors.any()" class="mb--md c--danger">
            <div v-for="error in errors.all()">{{ error }}</div>
        </div>

        <div class="mb--30">
            <div class="mb--lg">
                <input type="text" class="form-control form-control--dark" id="code" placeholder="Code" v-model="code">
            </div>

            <a class="btn btn--block btn--secondary" @click="redeemDiscount">Done</a>
        </div>

    </aside>
</template>

<script>
import discountApi from "../../api/discount";
import Errors from "../../util/Errors";

export default {
    name: "DiscountModal",
    data: function () {
        return {
            code: null,
            instance: null,
            errors: new Errors(),
            successMsg: null
        }
    },

    methods: {
        async redeemDiscount() {
            this.successMsg = null
            this.errors = new Errors()

            try {
                await discountApi.redeem(this.code)

                this.successMsg = 'You successfully redeemed the discount code.'
            } catch (error) {
                if (error.response.status === 422) {
                    this.errors.record(error.response.data.errors)
                }
            }
        },

        close() {
            this.instance.close()
        },

        open() {
            this.instance.open()
        },
    },

    mounted() {
        this.instance = $(this.$el).remodal({
            hashTracking: false
        });
    },
}
</script>

<style scoped>

</style>